import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import { Link } from "react-router-dom";

// Util
import MyButton from "../../util/MyButton";

// Post Attributes
import LikeButton from "./LikeButton";
import Comments from "./Comments";
import CommentForm from "./CommentForm";

// Material UI
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import UnfoldMore from "@material-ui/icons/UnfoldMore";
import ChatIcon from "@material-ui/icons/Chat";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import CardHeader from "@material-ui/core/CardHeader";
import CardActions from "@material-ui/core/CardActions";
import Avatar from "@material-ui/core/Avatar";
import Rating from "@material-ui/lab/Rating";

// Redux
import { connect } from "react-redux";
import { getPost, clearErrors } from "../../redux/actions/dataActions";

const styles = (theme) => ({
  ...theme.spreadThis,
  profileImage: {
    maxWidth: 200,
    height: 200,
    borderRadius: "50%",
    objectFit: "cover",
  },
  dialogContent: {
    padding: 20,
  },
  closeButton: {
    position: "absolute",
    left: "90%",
  },
  expandButton: {
    position: "absolute",
    left: "90%",
  },
  spinnerDiv: {
    textAlign: "center",
    marginTop: 50,
    marginBottom: 50,
  },
  card: {
    position: "relative",
    marginTop: 20,
  },
  media: {
    height: 550,
    paddingTop: "56.25%", // 16:9
  },
  content: {
    padding: 25,
    objectFit: "cover",
  },
});

class PostDialog extends Component {
  state = {
    open: false,
    oldPath: "",
    newPath: "",
  };
  componentDidMount() {
    if (this.props.openDialog) {
      this.handleOpen();
    }
  }
  handleOpen = () => {
    let oldPath = window.location.pathname;
    console.log(this.props)
    const { userHandle, postId } = this.props;
    const newPath = `/users/${userHandle}/post/${postId}`;

    if (oldPath === newPath) oldPath = `/users/${userHandle}`;

    window.history.pushState(null, null, newPath);

    this.setState({ open: true, oldPath, newPath });
    this.props.getPost(this.props.postId);
  };
  handleClose = () => {
    window.history.pushState(null, null, this.state.oldPath);
    this.setState({ open: false });
    this.props.clearErrors();
  };

  render() {
    //console.log(this.props)
    const {
      classes,
      //post: {
      currentPost: {
        postId,
        item,
        review,
        size,
        rating,
        createdAt,
        likeCount,
        commentCount,
        userImage,
        userHandle,
        comments,
        itemImage,
      },
      UI: { loadingPostDialog },
    } = this.props;
    const dialogMarkup = loadingPostDialog ? (
      <div className={classes.spinnerDiv}>
        <CircularProgress size={200} thickness={2} />
      </div>
    ) : (
      <Grid className={classes.card}>
        <CardHeader
          avatar={
            <Avatar
              alt={userHandle}
              src={userImage}
              component={Link}
              to={`/users/${userHandle}`}
            />
          }
          title={
            <Typography variant="body2" color="primary" component="p">
              <b>{userHandle}: </b>
              {item} <i>{size}</i>
            </Typography>
          }
          subheader={dayjs(createdAt).fromNow()}
        />

        <CardMedia image={itemImage} title={item} className={classes.media} />

        <CardContent>
          <Typography variant="body1" color="primary" component="p">
            <b>{userHandle}:</b> {review}
          </Typography>
          <Typography variant="body1" color="primary" component="p">
            <Rating name="read-only" value={rating} size="small" readOnly />
          </Typography>
        </CardContent>

        <CardActions disableSpacing>
          <LikeButton postId={postId} />
          <span>
            {likeCount} {likeCount === 1 ? "Like" : "Likes"}
          </span>
          <MyButton tip="comments">
            <ChatIcon color="primary" />
          </MyButton>
          <span>{commentCount} comments </span>
        </CardActions>
        <hr className={classes.visibleSeparator} />
        <CommentForm postId={postId} />
        {comments && <Comments comments={comments} />}
      </Grid>
    );
    return (
      <Fragment>
        <MyButton
          onClick={this.handleOpen}
          tip="Expand post"
          tipClassName={classes.expandButton}
        >
          <UnfoldMore color="primary" />
        </MyButton>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
          scroll="body"
        >
          <MyButton
            tip="Close"
            onClick={this.handleClose}
            tipClassName={classes.closeButton}
          >
            <CloseIcon />
          </MyButton>
          <DialogContent>{dialogMarkup}</DialogContent>
        </Dialog>
      </Fragment>
    );
  }
}

PostDialog.propTypes = {
  clearErrors: PropTypes.func.isRequired,
  getPost: PropTypes.func.isRequired,
  postId: PropTypes.string.isRequired,
  userHandle: PropTypes.string.isRequired,
  //post: PropTypes.object.isRequired,
  currentPost: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  //post: state.data.post,
  currentPost: state.data.currentPost,
  UI: state.UI,
});

const mapActionsToProps = {
  getPost,
  clearErrors,
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(withStyles(styles)(PostDialog));
